import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import RequireUserType from '../../routes/middleware/requireUserType';
import { addToFavouriteReq, getPurchaseRequisitionListReq } from '../../service/purchaseRequisitionService';
import { setBreadcrumbItems } from "../../store/Breadcrumb/actions";
import { changePreloader } from "../../store/actions";
import { USER_TYPES_ENUM } from '../../utility/constants';
import { formatDate } from '../../utility/formatDate';
import DropdownMenuBtn from '../Orders/DropdownMenuBtn';
import OrderStatusRenderer from '../Orders/OrderStatusRenderer';
import useAuth from '../../hooks/useAuth';


const AllRequisition = (props) => {
  document.title = "All Purchase Requisition";
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const autoSizeStrategy = {
    type: 'fitGridWidth'
  };
  const paginationPageSizeSelector = [25, 50, 100];
  const {selectedBranches}=useAuth()
  const [rowData, setRowData] = useState([]);
  const [paginationPageSize, setPaginationPageSize] = useState(100);
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState();
  const [inputValue, setInputValue] = useState('');
  const [sortData, setSortData] = useState({
    key: 'createdAt',
    order: "desc"
  });


  const timerRef = useRef(null);
  const [status,setStatus]=useState('')

  const redirectToViewPage = (id) => {
    let path = `/purchase-requisitions/${id}`;
    setTimeout(() => {
      navigate(path, id);
    }, 300);
  };

  const handleViewClick = (id) => {
    redirectToViewPage(id.purchaseRequisitionId);
  }

  useEffect(() => {
    props.setBreadcrumbItems('Purchase Requisitions', breadcrumbItems);
  }, []);

  useEffect(() => {
    let body = {
      page: page,
      limit: paginationPageSize,
      branchId:selectedBranches
    }
    if (searchValue) {
      body.search = searchValue
    }
    if (sortData) {
      body.sort = sortData
    }
    if(status){
      body.status=status
    }
    getListOfRowData(body);
  }, [page, paginationPageSize, searchValue, sortData,status,selectedBranches]);

  const getListOfRowData = useCallback(async (body) => {
    if (rowData[(page - 1) * paginationPageSize]) {
     dispatch(changePreloader(true));
    }
    dispatch(changePreloader(true));
   
    try {
      const response = await getPurchaseRequisitionListReq(body);


      if (!response?.data || !Array.isArray(response.data)) return;

      const res = response.data.map(requisition => ({
        purchaseRequisitionId: requisition._id,
        purchaseRequisitionNumber: requisition.purchaseRequisitionNumber || "-",
        purchaseOrderNumber: requisition.purchaseOrderNumber || "-",
        client_name: requisition.clientId?.name || "-",
        createdAt: formatDate(requisition.createdAt),
        branch_name: requisition.billing.branchName || "-",
        PRStatus: requisition.PRStatus,
      }));
      const emptyObjects = Array.from(
        { length: paginationPageSize },
        () => null
      );

      let filledRows;

      if (res.length < paginationPageSize) {
        filledRows = [...res];
      } else {
        filledRows = [...res, ...emptyObjects];
      }

      const newData = [...rowData];

      newData.splice(
        (page - 1) * paginationPageSize,
        paginationPageSize,
        ...filledRows
      );

      setRowData(newData);


    } catch (error) {
      console.error("Error fetching purchase requisitions:", error);
    } finally {
      dispatch(changePreloader(false));
    }
  }, [page, paginationPageSize,sortData,searchValue,status]);

  const redirectToEditPage = (id) => {
    let path = `/purchase-requisitions/${id.purchaseRequisitionId}/edit`;
    setTimeout(() => {
      navigate(path);
    }, 300);
  }
  const headerTemplate=(props)=>{
    const {handleSort,data}=props
    return (
      <button onClick={()=>handleSort(data,sortData)}
      style={{background:'transparent',border:'none'}}>
          <span style={{ fontWeight: 600 }}>
          {data?.displayName}&nbsp;

          {sortData?.key === data?.column?.userProvidedColDef?.field && (
            <i
              className={
                sortData?.order === "asc"
                  ? "mdi mdi-arrow-up"
                  : "mdi mdi-arrow-down"
              }
            />
          )}
        </span>
      
      </button>
    )

  }
  const handleSort=(data,sortData)=>{
    if(data.column.userProvidedColDef.field===sortData?.key)
    {
      setSortData({
        ...sortData,
        order:sortData?.order==='asc'?'desc':'asc'
      })
      
    }
    else{
      setSortData({
        key:data.column.userProvidedColDef.field,
        order:'desc'
      })
    }
    setPage(1)
    setRowData([])


  }

  const handleDeleteResponse = (response) => {
    if (response.success === true) {
      notify("Success", response.message);
    } else {
      notify("Error", response.message);
    }
    getListOfRowData();
  }

  const redirectToCopyPage = (id) => {
    let path = `/purchase-requisitions/${id.purchaseRequisitionId}/copy`;
    setTimeout(() => {
      navigate(path);
    }, 300);
  }

  const handleEditClick = (id) => {
    redirectToEditPage(id);
  }

  const handleCopyClick = (id) => {
    redirectToCopyPage(id);
  }


 const handleAddToFavourite = async (row) => {
  try {
    const requisitionId = row?.purchaseRequisitionId;

    if (!requisitionId) {
      notify("Error", "Invalid requisition ID");
      return;
    }

    const response = await addToFavouriteReq(requisitionId);
     if (response?.success) {
      notify("Success", "added to favourite successfully");
      getListOfRowData();
    } else {
      notify("Error", response?.message || "Failed to add order");
    }
  } catch (error) {
    console.error("ERROR:", error);
    notify("Error", "already exists");
  }
};

  const onPaginationChanged = useCallback(() => {
    const api = gridRef.current?.api;
    if (!api) return;

    const pageSize = api.paginationGetPageSize();

    setPaginationPageSize(prev => {
      if (prev !== pageSize) return pageSize;
      return prev;
    });

    const newPage = api.paginationGetCurrentPage() + 1;

    setPage(prev => (prev !== newPage ? newPage : prev));
  }, []);


  const handleInputChange = (e) => {
    setInputValue(e.target.value?.trim());
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      setRowData([]);
      setPage(1);
      setSearchValue(e.target.value?.trim());
    }, 2000);
  };

  const gridRef = useRef(null);

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Purchase Requisitions", link: "#" },
  ];

  const columnDefs = [
    {
      headerName: "PR No.",
      field: "purchaseRequisitionNumber",
      suppressMenu: true,
      minWidth: 150,
      sortable: false,
      headerComponent:headerTemplate,
      headerComponentParams:(props)=>({
        handleSort:handleSort,
        data:props,
        sortData

      }),
      cellRenderer: (params) => {
        if (!params.data) return "-";
        const prId = params.data?.purchaseRequisitionId;
        const number = params.data.purchaseRequisitionNumber;

        return (
          <span
            style={{
              cursor: number !== '-' ? "pointer" : "default",
              color: number !== '-' ? "#007bff" : "inherit",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (number !== '-') navigate(`/purchase-requisitions/${prId}`);
            }}
          >
            {number || "-"}
          </span>
        );
      },
    },
    {
      headerName: "PO No.",
      field: "purchaseOrderNumber",
      suppressMenu: true,
      sortable:false,
      minWidth: 120,
      cellRenderer: (params) => {
        if (!params.data) return "-";
        const poNumber = params.value;
        const prId = params.data?.purchaseRequisitionId;

        if (!poNumber) return "-";

        return (
          <span
            style={{
              cursor: poNumber !== '-' && "pointer",
              color: poNumber !== '-' && "#007bff",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (poNumber !== '-') navigate(`/purchase-orders/${prId}`);
            }}
          >
            {poNumber}
          </span>
        );
      },
    },
    {
      headerName: 'Branch',
      field: 'branch_name',
      minWidth: 250,
      sortable:false,
      comparator: () => false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      tooltipValueGetter: (p) => p.value,
      headerTooltip: "Branch",
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        textAlign: 'left',
      },
      cellRenderer: (params) => (
        <span>{params.value}</span>
      ),
    },
    {
      headerName: "Created Date", 
      field: "createdAt", 
      suppressMenu: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      
      tooltipValueGetter: (p) => p.value, headerTooltip: "Created Date",
       minWidth: 150,
      sortable: false,
      headerComponent:headerTemplate,
      headerComponentParams:(props)=>({
        handleSort:handleSort,
        data:props,
        sortData

      }),
     
    },
    {
      headerName: "Status",
      field: "PRStatus",
      suppressMenu: true,
      minWidth: 150,
      cellStyle: {
        textAlign: "left",
        display: "flex",
        justifyContent: "flex-start",
      },
       sortable:true,
    

      cellRenderer: (params) => (
        <OrderStatusRenderer value={params.value} type="pr" />
      ),
    },
    {
      headerName: "Action", field: "action", sortable: false, width: 100,
      cellClass: "actions-button-cell",
      cellRenderer: DropdownMenuBtn,
      cellRendererParams: {
        handleEditClick: handleEditClick,
        handleViewClick: handleViewClick,
        handleCopyClick: handleCopyClick,
        handleAddToFavourite:handleAddToFavourite
      
      }, suppressMenu: true, floatingFilterComponentParams: { suppressFilterButton: true },
      tooltipValueGetter: (p) => p.value, headerTooltip: "Actions",
    }
  ];

  const notify = (type, message) => {
    if (type === "Error") {
      toast.error(message, {
        position: "top-center",
        theme: "colored",
      })
    } else {
      toast.success(message, {
        position: "top-center",
        theme: "colored",
      })
    }
  }
  return (
    <>
      <div className="all-items">
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <div className="button-section">
                  <div className="button-right-section">
                    <div className="invoice-search-box">
                      <div className="search-box position-relative" style={{ width: '16rem' }}>
                        <Input
                          type="text"
                          value={inputValue}
                          onChange={handleInputChange}
                          className="form-control rounded border"
                          placeholder={"Search by Requisition Number"}

                        />
                        <i className="mdi mdi-magnify search-icon"></i>
                      </div>
                    </div>
                     <div>
                    <select value={status} onChange={(e)=>
                      
                      setStatus(e.target.value)
                    } className="form-select form-control rounded border" >
                    
                    <option value="">All status</option>
                    <option value="draft">Unsent</option>
                    <option value="published">Sent</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                    </select>
                  
                </div>
                  </div>
                  <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                    <Button variant="contained" sx={{ backgroundColor: '#0053FF', ml: 2 }}
                      onClick={() => navigate("/create-requisition")}
                    >
                      <Add sx={{ mr: 1 }} /> {"Add PR"}
                    </Button>
                  </RequireUserType>
                </div>
                <div
                  className="ag-theme-quartz"
                  style={{
                    height: '550px',
                    width: '100%'
                  }}
                >
                  <AgGridReact
                    ref={gridRef}
                    suppressRowClickSelection={true}
                    columnDefs={columnDefs}
                    pagination={true}
                    paginationPageSize={paginationPageSize}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                    autoSizeStrategy={autoSizeStrategy}
                    rowData={rowData}
                    reactiveCustomComponents
                    onPaginationChanged={onPaginationChanged}
                    
                    
                  >
                  </AgGridReact>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default connect(null, { setBreadcrumbItems })(AllRequisition);
